export enum CaptureMethodStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}
